import React, { useState } from 'react';
import {
	Button,
	Grid,
	MenuItem,
	Paper,
	Select,
	Typography,
	FormControl,
	InputLabel,
} from '@mui/material';
import { green } from '@mui/material/colors';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
	apiCreateUserClient,
	IUserBackEnd,
	IClientBackend,
} from '../../../services/apiService';

interface AddUserClientProps {
	users: IUserBackEnd[];
	clients: IClientBackend[];
	updatedDataToggle: boolean;
	setUpdatedDataToggle: React.Dispatch<React.SetStateAction<boolean>>;
}

const AddUserClient: React.FC<AddUserClientProps> = ({
	users,
	clients,
	updatedDataToggle,
	setUpdatedDataToggle,
}) => {
	const [relation, setRelation] = useState<{
		userId: number | '';
		clientId: number | '';
	}>({ userId: '', clientId: '' });

	const handleAdd = async () => {
		if (!relation.userId || !relation.clientId) {
			toast.warning('Selecione usuário e cliente');
			return;
		}
		try {
			await apiCreateUserClient({
				user_id: relation.userId as number,
				client_id: relation.clientId as number,
			});
			setRelation({ userId: '', clientId: '' });
			setUpdatedDataToggle(!updatedDataToggle);
			toast.success('Relação adicionada com sucesso');
		} catch (error) {
			toast.error('Erro ao adicionar relação');
		}
	};

	return (
		<Grid item xs={12} style={{ marginBottom: 27 }}>
			<Paper elevation={5} style={{ padding: 20 }}>
				<Typography
					variant="h6"
					component="h3"
					style={{ marginBottom: '20px' }}
				>
					Nova relação Usuário-Cliente
				</Typography>
				<Grid container spacing={2} alignItems="center">
					<Grid item xs={3}>
						<FormControl fullWidth variant="outlined">
							<InputLabel id="user-select-label">Usuário</InputLabel>
							<Select
								labelId="user-select-label"
								value={relation.userId}
								onChange={e =>
									setRelation(prev => ({
										...prev,
										userId: Number(e.target.value),
									}))
								}
								label="Usuário"
							>
								{users
									.sort((a, b) => a.username.localeCompare(b.username))
									.map(user => (
										<MenuItem key={user.id} value={user.id}>
											{user.username}
										</MenuItem>
									))}
							</Select>
						</FormControl>
					</Grid>
					<Grid item xs={3}>
						<FormControl fullWidth variant="outlined">
							<InputLabel id="client-select-label">Cliente</InputLabel>
							<Select
								labelId="client-select-label"
								value={relation.clientId}
								onChange={e =>
									setRelation(prev => ({
										...prev,
										clientId: Number(e.target.value),
									}))
								}
								label="Cliente"
							>
								{clients
									.sort((a, b) => a.client_name.localeCompare(b.client_name))
									.map(client => (
										<MenuItem key={client.id} value={client.id}>
											{client.client_name}
										</MenuItem>
									))}
							</Select>
						</FormControl>
					</Grid>
					<Grid item xs={2}>
						<Button
							variant="contained"
							sx={{
								backgroundColor: green[500],
								'&:hover': { backgroundColor: green[700] },
								color: 'white',
							}}
							onClick={handleAdd}
						>
							<strong>Adicionar</strong>
						</Button>
					</Grid>
				</Grid>
			</Paper>
			<ToastContainer />
		</Grid>
	);
};

export default AddUserClient;
